import React, { ReactElement } from 'react';

import { Stamp, StampIcon } from '@philips-emr/tws-components';
import { Color } from '@philips-emr/tws-constants';

enum ActionTypes {
  CHANGED = 'A',
  DELETED = 'E',
  INCLUDED = 'I',
  NO_IMPACT = 'N',
}

function getStampUpdateStatus(ieAction: ActionTypes, label: string): ReactElement {
  let stampProps = null;

  const icon = {
    [ActionTypes.CHANGED]: { color: Color.SAFETY_YELLOW, icon: StampIcon.WARNING, label },
    [ActionTypes.DELETED]: { color: Color.SAFETY_RED, icon: StampIcon.CANCELED, label },
    [ActionTypes.INCLUDED]: { color: Color.SAFETY_GREEN, icon: StampIcon.CHECK, label },
    [ActionTypes.NO_IMPACT]: { color: Color.SAFETY_NEUTRAL, icon: StampIcon.CHECK, label },

  };

  stampProps = icon[ieAction];
  return <Stamp {...stampProps} />;
}

export {
  getStampUpdateStatus,
  ActionTypes,
};
